import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Pressable,
  Text,
  ScrollView,
} from "native-base";
import { createPortal } from "react-dom";

import { GlobalStyles } from "../constants/styles";

const CustomPopup = (props) => {
  const [isOpen, setIsOpen] = useState(props.data);

  useEffect(() => {
    setIsOpen(props.data);
  }, [props.data]);

  const onClose = () => {
    setIsOpen(false);
    props.onChange(false);
  };

  const onOk = () => {
    setIsOpen(false);
    props.onChange(true);
  };

  if (!isOpen) {
    return null;
  }

  const popup = (
    <div
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100dvh",
        zIndex: 2147483647,

        // Important
        isolation: "isolate",
      }}
    >
      {/* =========================
          FULL SCREEN BACKDROP
      ========================= */}
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          width: "100vw",
          height: "100dvh",

          backgroundColor: "rgba(0, 0, 0, 0.5)",

          zIndex: 0,
        }}
      />

      {/* =========================
          CENTER CONTAINER
      ========================= */}
      <div
        style={{
          position: "fixed",
          inset: 0,

          width: "100vw",
          height: "100dvh",

          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          zIndex: 1,

          pointerEvents: "none",
        }}
      >
        {/* =========================
            DIALOG
        ========================= */}
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            width: "min(500px, 90vw)",
            maxWidth: "550px",

            maxHeight: "80dvh",

            backgroundColor: "#ffffff",

            borderRadius: "8px",

            boxShadow:
              "0 10px 40px rgba(0,0,0,0.35)",

            overflow: "hidden",

            display: "flex",
            flexDirection: "column",

            pointerEvents: "auto",
          }}
        >
          {/* =========================
              HEADER
          ========================= */}
          <div
            style={{
              position: "relative",

              padding: "16px 50px 16px 24px",

              borderBottom:
                "1px solid #e5e7eb",

              fontSize: "18px",

              fontWeight: 600,

              color: "#1f2937",
            }}
          >
            {props.heading}

            {/* CLOSE */}
            <button
              type="button"
              onClick={onClose}
              style={{
                position: "absolute",

                right: "10px",
                top: "50%",

                transform:
                  "translateY(-50%)",

                width: "32px",
                height: "32px",

                border: "none",

                background: "transparent",

                cursor: "pointer",

                fontSize: "24px",

                color: "#6b7280",

                padding: 0,
              }}
            >
              ×
            </button>
          </div>

          {/* =========================
              BODY
          ========================= */}
          <div
            style={{
              padding: "16px 24px",

              overflowY: "auto",

              maxHeight: "400px",

              userSelect: "text",

              WebkitUserSelect: "text",

              cursor: "text",
            }}
          >
            {props.body}
          </div>

          {/* =========================
              FOOTER
          ========================= */}
          <div
            style={{
              padding: "12px 24px",

              borderTop:
                "1px solid #e5e7eb",

              display: "flex",

              justifyContent: "flex-end",
            }}
          >
            <Button
              bg={GlobalStyles.colors.blue}
              onPress={onOk}
            >
              Ok
            </Button>
          </div>
        </div>
      </div>
    </div>
  );

  // IMPORTANT:
  // Render popup directly under document.body
  return createPortal(
    popup,
    document.body
  );
};

export default CustomPopup;